/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1IndividualpaymentParcelsParcelidInvoices200,
  GetApiV1IndividualpaymentParcelsParcelidInvoices401,
  GetApiV1IndividualpaymentParcelsParcelidInvoices500,
  GetApiV1IndividualpaymentParcelsParcelidInvoicesPathParams,
  GetApiV1IndividualpaymentParcelsParcelidInvoicesQueryParams,
  GetApiV1IndividualpaymentParcelsParcelidInvoicesQueryResponse,
} from "../../types/individualPaymentParcelsController/GetApiV1IndividualpaymentParcelsParcelidInvoices.ts";
import { individualPaymentInvoiceViewModelSchema } from "../individualPaymentInvoiceViewModelSchema.ts";

export const getApiV1IndividualpaymentParcelsParcelidInvoicesPathParamsSchema =
  z.object({
    parcelId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1IndividualpaymentParcelsParcelidInvoicesPathParams>;

export const getApiV1IndividualpaymentParcelsParcelidInvoicesQueryParamsSchema =
  z.object({
    culture: z.string().default("pt-BR"),
  }) as unknown as ToZod<GetApiV1IndividualpaymentParcelsParcelidInvoicesQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1IndividualpaymentParcelsParcelidInvoices200Schema =
  z.array(
    z.lazy(() => individualPaymentInvoiceViewModelSchema),
  ) as unknown as ToZod<GetApiV1IndividualpaymentParcelsParcelidInvoices200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1IndividualpaymentParcelsParcelidInvoices401Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentParcelsParcelidInvoices401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1IndividualpaymentParcelsParcelidInvoices500Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentParcelsParcelidInvoices500>;

export const getApiV1IndividualpaymentParcelsParcelidInvoicesQueryResponseSchema =
  z.lazy(
    () => getApiV1IndividualpaymentParcelsParcelidInvoices200Schema,
  ) as unknown as ToZod<GetApiV1IndividualpaymentParcelsParcelidInvoicesQueryResponse>;
